<template>
	<div>
		<article v-if="isPromotionDetail" class="promotion-article">
			<div class="promotion-article__content u-container">
				<div class="prom-title-box">
					<h2 class="prom-title-box__title">
						{{ promotionDetail.wp_subject }}
					</h2>
					<p class="prom-title-box__date">
						{{ promotionDetail.wp_startdate }} ~
						{{ promotionDetail.wp_enddate }}
					</p>
				</div>

				<div class="prom-upload">
					<img :src="getPromotionUrl(promotionDetail.wp_filename)" alt="" />
				</div>
			</div>

			<div class="promotion-article__help u-container">
				<p>※자세한 내용은 지점으로 문의 바랍니다.</p>
			</div>
		</article>
	</div>
</template>

<script>
import { fetchPromotionDetail } from '@/api';

export default {
	data() {
		return {
			isPromotionDetail: false,
			promotionDetail: {},
		};
	},
	computed: {
		id() {
			return this.$route.params.id;
		},
	},
	methods: {
		getPromotionUrl(filename) {
			const S3_BASE_URL = process.env.VUE_APP_S3_BASE_URL;
			const basePath = '/himo-app/uploads/promotion/';

			const hasFullPath = filename.includes(basePath);
			const uploadPath = hasFullPath
				? `${S3_BASE_URL}${filename}`
				: `${S3_BASE_URL}${basePath}${filename}`;

			return uploadPath;
		},
		init() {
			this.renderPromotionDetail();
		},
		async renderPromotionDetail() {
			const params = {
				id: this.id,
			};

			const { data } = await fetchPromotionDetail(params);

			if (data.code === '00000') {
				this.isPromotionDetail = true;
				this.promotionDetail = data.promotionDetail;
			}
		},
	},
	created() {
		this.init();
	},
};
</script>
